<template>
  <img :src="url" :alt="alt" @load.once="loaded" />
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ImageC',
  data() {
    return {
      width: 420,
    };
  },
  emits: ['load'],
  props: {
    srcSuffix: { required: true },
    alt: { required: false },
  },
  computed: {
    ...mapState({
      publicURL: (state) => state.app.API_PUBLIC_URL,
    }),
    url() {
      if (this.srcSuffix === null) {
        return '';
      }
      return `${this.publicURL}${this.width}/${this.srcSuffix}`;
    },
  },
  methods: {
    loaded() {
      this.$emit('load', this.$el);
    },
    calculateImageSize() {
      // find parent width and pixel density request adequate image round up to nearest 500px
      const retinaMultiplier = window.devicePixelRatio;
      const parentWidth = this.$el.parentElement.clientWidth;
      const finalWidth = parentWidth * retinaMultiplier;
      let finalWidthRounded = Math.ceil(finalWidth / 500) * 500;
      if (finalWidthRounded > 2000) {
        finalWidthRounded = 2000;
      }
      if (finalWidthRounded !== 0) {
        this.width = finalWidthRounded;
      }
    },
  },
  mounted() {
    this.calculateImageSize();
    const resizeObserver = new ResizeObserver(() => {
      this.calculateImageSize();
    });

    resizeObserver.observe(this.$el.parentElement);
  },
};
</script>
